// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rel-container {
  position: relative;
}

.loading-button {
  position: relative;
  left: 0;
  right: 0;
  margin: 2% auto;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/component/show-more-button/show-more-button.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,eAAe;AACjB","sourcesContent":[".rel-container {\n  position: relative;\n}\n\n.loading-button {\n  position: relative;\n  left: 0;\n  right: 0;\n  margin: 2% auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
